import React, { lazy, Suspense, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { FolderOpen } from "@mui/icons-material";
import { getConciliationFilesById } from "modules/finops/conciliaciones/services/financieraService";
const documentKey = (value) =>
  String(value ?? "")
    .trim()
    .replace(/^PRE_(?=\d+$)/, "");
const ModalPDF = lazy(() => import("../conciliaciones/lotesFinanciera/components/ModalPDF"));

export default function ConcessionDocuments({
  conciliationId,
  code,
  keyConcil,
  refreshing = false,
}) {
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  useEffect(() => {
    setFiles([]);
    setOpen(false);
    if (refreshing || !conciliationId || !code) return undefined;
    const controller = new AbortController();
    getConciliationFilesById(conciliationId, code, controller.signal)
      .then((result) => {
        if (controller.signal.aborted || !result.success) return;
        setFiles(
          (Array.isArray(result.data) ? result.data : []).filter(
            (file) =>
              file.id != null &&
              (!documentKey(file.key_concil) ||
                documentKey(file.key_concil) === documentKey(keyConcil)) &&
              String(file.code_op) === String(code) &&
              String(file.concil_id) === String(conciliationId)
          )
        );
      })
      .catch(() => {
        /* El servicio informa el error; Actualizar vuelve a consultar. */
      });
    return () => controller.abort();
  }, [refreshing, conciliationId, code, keyConcil]);
  if (!files.length) return null;
  return (
    <>
      <Tooltip title={`Ver documentos de financiera (${files.length})`} arrow>
        <IconButton
          aria-label={`Documentos de la llave ${keyConcil}`}
          onClick={() => setOpen(true)}
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            border: "1px solid",
            borderColor: "rgba(211,47,47,0.3)",
            color: "error.main",
            bgcolor: "rgba(211,47,47,0.07)",
            "& .MuiSvgIcon-root": { fontSize: 18 },
            "&:hover": { bgcolor: "rgba(211,47,47,0.14)", borderColor: "error.main" },
          }}
        >
          <FolderOpen fontSize="small" />
        </IconButton>
      </Tooltip>
      {open && (
        <Suspense fallback={<CircularProgress aria-label="Cargando visor de documentos" />}>
          <ModalPDF open onClose={() => setOpen(false)} keyConcil={keyConcil} filesData={files} />
        </Suspense>
      )}
    </>
  );
}
ConcessionDocuments.propTypes = {
  conciliationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  keyConcil: PropTypes.string.isRequired,
  refreshing: PropTypes.bool,
};
